import productData from './products.json';
import { AppServiceId } from './build';

export type ToolId = AppServiceId;

export interface ProductConfig {
  id: string;
  name: string;
  image?: string;
  externalUrl?: string;
  tools: ToolId[];
}

export const products = productData as ProductConfig[];

export const getProduct = (productId?: string | null) =>
  products.find(product => product.id === productId);

export const getFirstProductForTool = (toolId?: ToolId) =>
  products.find(product => !!toolId && product.tools.includes(toolId));

export const getAvailableProductTools = (
  product: ProductConfig | undefined,
  availableTools: ToolId[],
) => product?.tools.filter(toolId => availableTools.includes(toolId)) ?? [];
